export default __webpack_public_path__ + "27ec3497e6367654011019303c3b34c0.woff2";